import { Paginator } from '@app/classes';
import { TemplateType } from '@app/modules/performance/enums/template-type.enum';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { Template } from '@models/performance/template.model';
import { DateCreatedColumn, DescriptionColumn, TitleColumn } from '@performance/services/tables/template-table/columns';

export class TemplateIndexTable extends Table {
    links = true;

    showMenuColumnOptions = false;

    static duplicateOption: MenuColumnItem = {
        label: 'duplicate',
        event: 'duplicate',
    };

    static deleteOption: MenuColumnItem = {
        label: 'delete',
        event: 'delete',
    };

    constructor(
        private companyId: number,
        private type: TemplateType,
        private hasPerformanceModuleSplit: boolean
    ) {
        super();
        this.boot();
    }

    getMenuColumnOptionsForRow(): MenuColumnItem[] {
        return [TemplateIndexTable.duplicateOption, TemplateIndexTable.deleteOption];
    }

    getLink(template: Template): (string | number)[] {
        return ['/performance', 'templates', template.id];
    }

    setColumns(): void {
        this.addColumns(new TitleColumn(), new DescriptionColumn(), new DateCreatedColumn());
    }

    setDataSource(): void {
        const query = Template.param('company', this.companyId);

        this.paginator = new Paginator(this.hasPerformanceModuleSplit ? query.where('type', this.type) : query);
    }
}
